"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const mobx_react_1 = require("mobx-react");
require("./index.scss");
const SongwriterMyWritersRow_1 = __importDefault(require("@Scenes/SongwriterScene/SongwriterMyWritersScene/SongwriterMyWritersTable/SongwriterMyWritersRow"));
const SongwriterMyWritersTable = ({ data, onTitleClick, linkedWriterIpIds, onWriterToggle, }) => (react_1.default.createElement("div", { className: 'songwriter-my-writer-table' },
    react_1.default.createElement("div", { className: 'songwriter-my-writer-table-headers' },
        react_1.default.createElement("div", null, "In Catalog?"),
        react_1.default.createElement("div", null, "My Writer Name"),
        react_1.default.createElement("div", null, "Number of Songs")),
    react_1.default.createElement("div", { className: 'songwriter-my-writer-table-body' }, data.map((writer) => (react_1.default.createElement(SongwriterMyWritersRow_1.default, { key: writer.ipId, writer: writer, onWriterToggle: onWriterToggle, onTitleClick: onTitleClick, isChecked: linkedWriterIpIds.has(Number(writer.ipId)) }))))));
exports.default = (0, mobx_react_1.observer)(SongwriterMyWritersTable);
